import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

@Pipe({
    name: 'dateFormat',
    standalone: false
})
export class DateFormatPipe implements PipeTransform {
    transform(value: any, format: string = 'DD/MM/YYYY'): string | null {
        const m = moment(value);

        if(m) {
            return m.format(format);
        }
        
        return value;
    }
}